<div [formGroup]="form">
  <div class="row">
    <app-field
      label="Primary Race/Ethnicity"
      class="col-md-12"
      [required]="false"
      [disabled]="isDisabled"
      errorMessage="Please select an option">
      <select class="form-control" [formControlName]="raceEthnicityFormControlName">
        @for (enum of raceEthnicityList; track enum) {
          <option [value]="enum.val">{{ enum.name }}</option>
        }
      </select>
    </app-field>
  </div>
  <div class="row">
    @if (isPersonIndigenous) {
      <app-field
        label="Indigenous"
        class="col-md-12"
        [required]="false"
        [disabled]="isDisabled"
        errorMessage="Please select an option">
        <select class="form-control" [formControlName]="indigenousStatusFormControlName">
          @for (enum of indigenousStatusList; track enum) {
            <option [value]="enum.val">{{ enum.name }}</option>
          }
        </select>
      </app-field>
    }
  </div>
  <div class="row">
    @if (showOtherRaceEthnicity) {
      <app-field
        label="Other Race/Ethnicity"
        class="col-md-12"
        [required]="false"
        errorMessage="Please enter your gender"
        [disabled]="isDisabled">
        <label class="inline-label">
          <input
            type="text"
            [name]="otherRaceEthnicityFormControlName"
            [formControlName]="otherRaceEthnicityFormControlName" />
          </label>
        </app-field>
      }
    </div>
  </div>
